import { Box } from "@chakra-ui/react";
import React, { useState } from "react";
import DynamicBlocks from "./DynamicInputBlocks";
import { commonStyle } from "../../../styles/commonStyle";

function InputBlockMain({
  Userblocks,
  setUserBlocks,
  UserSystemblocks,
  setUserSystemblocks,
  formData,
  setFormData,
  errorset={errorset}
}) {
  return (
    <Box overflowY="auto" sx={{ ...commonStyle.sx,scrollBehavior: "smooth", }} h={"70vh"}>
      <DynamicBlocks
        title={"User Message"}
        setBlocks={setUserBlocks}
        blocks={Userblocks}
        formData={formData}
        setFormData={setFormData}
        errorset={errorset}
      />
      <DynamicBlocks
        title={"System Message"}
        setBlocks={setUserSystemblocks}
        blocks={UserSystemblocks}
        formData={formData}
        setFormData={setFormData}
      />
    </Box>
  );
}

export default InputBlockMain;
